module.exports = __webpack_public_path__ + "static/img/205.f22bbdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/201206/205.jpg
// module id = mo6S
// module chunks = 0